import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityPrintsRoutes: MenuInterface[] = [
    {
        code: 'GestionImpressionEtatStocks_ViewModel',
        route: [
            {
                content: 'activity/prints/stock-status/criteria',
                focus: 'activity/prints/stock-status/informations',
            }, 'content'
        ]
    },
    {
        code: 'PrintSalesBalance',
        route: [
            {
                content: '$type/prints/orders/criteria',
                focus: '$type/prints/orders/informations',
            }, 'content'
        ]
    },
    {
        code: 'PrintDashboard',
        route: [
            {
                content: '$type/prints/dashboard/criteria',
                focus: '$type/prints/dashboard/document',
            }, 'content'
        ]
    },
    {
        code: 'PrintDashboardInvoices',
        route: [
            {
                content: '$type/prints/dashboard-invoices/criteria',
                focus: '$type/prints/dashboard-invoices/document',
            }, 'content'
        ]
    }
];
